import {layoutStyles} from "@client/site/Layout";
import React from "react";

interface FooterBlockProps {
    title: string;
    links: ReadonlyArray<{title: string; to: string}>;
}

export const FooterBlock = (props: FooterBlockProps) => (
    <div className={layoutStyles.footerBlock}>
        <div className={layoutStyles.footerHeader}>{props.title}</div>
        <ul className={layoutStyles.footerLinks}>
            {props.links.map((link, index) => (
                <li key={index}>
                    <a href={link.to}>{link.title}</a>
                </li>
            ))}
        </ul>
    </div>
);
